import { SingleIncludedUserResourcePermissionResource } from 'api-user-client'
import { equals } from 'ramda'
import { useMutation, useQuery } from 'react-query'
import { useDispatch } from 'react-redux'

import { getMe, setLastLoginDate } from '~shared-components/api/users'
import { SharedQueryOptions } from '~shared-components/hooks/useLoggedInUser'
import { heapIdentifyUser } from '~shared-components/redux/actions/login.actions'
import { isServer } from '~shared-components/utils'
import { QueryCacheKey } from '~shared-components/utils/enums'

interface Parameters {
  isEnabled?: boolean
  onError?: () => void
}
export const useInitUser = (parameters: Parameters = {}) => {
  const dispatch = useDispatch()
  const { isEnabled = true, onError } = parameters

  const { mutateAsync: setLoginDate } = useMutation<
    SingleIncludedUserResourcePermissionResource,
    unknown,
    { date: Date; user: SingleIncludedUserResourcePermissionResource }
  >(setLastLoginDate)

  return useQuery([QueryCacheKey.User, 'me'], getMe, {
    ...SharedQueryOptions,
    enabled: !isServer() && isEnabled,
    // Disables the checking if the JSON response is equal, due to the response having looping references -_-;
    // So instead we use our own isDataEqual
    // structuralSharing: false is requried for custom equality
    isDataEqual: (p1, p2) => equals(p1, p2),
    onError,
    onSuccess: async data => {
      if (!data.me) {
        throw new Error('Failed retrieving user data')
      }
      dispatch(heapIdentifyUser(data.me.data.attributes.email))

      const date = new Date()
      await setLoginDate({ date, user: data.me })
    },
    refetchOnWindowFocus: false,
    structuralSharing: false,
  })
}
